import { useSelector, useDispatch } from 'react-redux';
import { useNavigate,useLocation,useParams } from 'react-router-dom'; // If needed for navigation
import * as jobSummaryActions from 'actions/jobSummaryActions';
import { getDefinitionForWorkflow } from 'selectors/jobTableDefinitionSelector';
import JobTable from './JobTable';
import React from 'react';

const JobTableContainer = (ownProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // If you need to navigate
  const location = useLocation();
    const { state: routeState } = useParams(); 
  const jobSummaries = useSelector((state) => state.jobSummaries);
  const normalizedState = routeState ? routeState.replace('-', ' ') : 'assigned';
   const jobTableDefinition = useSelector((state) =>
    getDefinitionForWorkflow(state, normalizedState));
 

  const actions = {
    ...jobSummaryActions,
    // Bind actions if necessary
    // Example: fetchJobSummaries: () => dispatch(jobSummaryActions.fetchJobSummaries())
  };

  return (
    <JobTable
    {...ownProps}
    onRowClick = {ownProps.onRowClick}
    onPageChange={ownProps.onPageChange}
    onHeaderClick={ownProps.onHeaderClick}
      jobSummaries={jobSummaries}
      jobTableDefinition={jobTableDefinition}
      actions={actions}
      location={location}
     // location={navigate} // Pass navigate if needed
    />
  );
};

export default JobTableContainer;
